function clickTap(stage, layer, tr, textNode, id, fn) {
    stage.on("click tap ", (e) => {
        if (e.target !== stage) {
            // 遍历画布里面数组的层级 取出最大的一层
            var result = Math.max(...layer.children.map((x) => x.zIndex()));
            var bg = layer.children.filter(
                (item) => item.attrs.status === "background"
            );
            var fill = layer.children.filter(
                (item) => item.attrs.name === "fill"
            );

            // if (fill.length != 0 && e.target.attrs.status === "fill") {
            //     e.target.zIndex(0);
            // }



            if (bg.length !== 0 && e.target.attrs.status === "background") {
                e.target.zIndex(0);
            } else {
                //  当前图片置顶
                // e.target.moveToTop();
                //  当前缩放框置顶
                tr.moveToTop();



                let arr = layer.find(".grid");
                if (arr.length !== 0) {
                    layer.find(".grid").forEach((item) => {
                        item.moveToTop();
                    });
                }
            }

            layer.find(".fill").forEach(item => {
                item.zIndex(0)
            })


        }

        // if click on empty area - remove all selections
        // 如果单击空白区域-删除所有选择
        if (e.target === stage || e.target.attrs.name === 'fill') {
            tr.nodes([]);
            layer.draw();
            return;
        }
        // do nothing if clicked NOT on our rectangles
        // 如果点击不在矩形上，什么都不做
        if (e.target.getName().indexOf("rectTransformer") === -1) {
            return;
        }

        if (e.target !== tr.nodes()[0]) {
            tr.nodes([e.target]);
            layer.draw();
        }










    });

    tr.on("transform", (e) => {
        // 监听变压器变化
        // console.log(layer.children[0].attrs.image.src)
        // images[0].rotation = e.target.attrs.rotation

    });

    if (textNode) {
        textNode.on('dblclick', (e) => {
            fn()
            textNode.hide();
            tr.hide();
            layer.draw();


            var textPosition = textNode.absolutePosition();

            // then lets find position of stage container on the page:
            var stageBox = stage.container().getBoundingClientRect();


            const zoom = document.body.style.zoom || 1;
            const scaleValue = (1 / zoom).toFixed(3);
            // so position of textarea will be the sum of positions above:
            var areaPosition = {
                x: stageBox.left * scaleValue + textPosition.x,
                y: stageBox.top * scaleValue + textPosition.y
            };
            // create textarea and style it
            var textarea = document.createElement('textarea');
            document.body.appendChild(textarea);
            textarea.value = textNode.text();
            textarea.style.position = 'absolute';
            textarea.style.top = areaPosition.y + 'px';
            textarea.style.left = areaPosition.x + 'px';
            textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px';
            textarea.style.height =
                textNode.height() - textNode.padding() * 2 + 5 + 'px';
            textarea.style.fontSize = textNode.fontSize() + 'px';
            textarea.style.border = 'none';
            textarea.style.padding = '0px';
            textarea.style.margin = '0px';
            textarea.style.overflow = 'hidden';
            textarea.style.background = 'none';
            textarea.style.outline = 'none';
            textarea.style.resize = 'none';
            textarea.style.letterSpacing = textNode.letterSpacing() + 'px';
            textarea.style.lineHeight = textNode.lineHeight();
            textarea.style.fontFamily = textNode.fontFamily();
            textarea.style.textDecoration = textNode.textDecoration();
            textarea.style.transformOrigin = 'left top';
            textarea.style.textAlign = textNode.align();
            textarea.style.color = textNode.fill();
            let rotation = textNode.getRotation();
            var transform = '';

            if (rotation) {
                transform += 'rotateZ(' + rotation + 'deg)';

            }


            var px = 0;
            // also we need to slightly move textarea on firefox
            // because it jumps a bit
            var isFirefox =
                navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isFirefox) {
                px += 2 + Math.round(textNode.fontSize() / 20);
            }
            transform += 'translateY(-' + px + 'px)';

            textarea.style.transform = transform;

            // reset height
            textarea.style.height = 'auto';
            // after browsers resized it we can set actual value
            textarea.style.height = textarea.scrollHeight + 3 + 'px';

            textarea.focus();

            function removeTextarea() {
                textarea.parentNode.removeChild(textarea);
                window.removeEventListener('click', handleOutsideClick);
                textNode.show();
                tr.show();
                tr.forceUpdate();
                layer.draw();
            }

            function setTextareaWidth(newWidth) {
                if (!newWidth) {
                    // set width for placeholder
                    newWidth = textNode.placeholder.length * textNode.fontSize();
                }
                // some extra fixes on different browsers
                var isSafari = /^((?!chrome|android).)*safari/i.test(
                    navigator.userAgent
                );
                var isFirefox =
                    navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                if (isSafari || isFirefox) {
                    newWidth = Math.ceil(newWidth);
                }

                var isEdge =
                    document.documentMode || /Edge/.test(navigator.userAgent);
                if (isEdge) {
                    newWidth += 1;
                }
                textarea.style.width = newWidth + 'px';
            }

            textarea.addEventListener('keydown', function (e) {
                // hide on enter
                // but don't hide on shift + enter
                if (e.keyCode === 13 && !e.shiftKey) {
                    textNode.text(textarea.value);
                    removeTextarea();
                }
                // on esc do not set value back to node
                if (e.keyCode === 27) {
                    removeTextarea();
                }
            });

            textarea.addEventListener('keydown', function (e) {
                let scale = textNode.getAbsoluteScale().x;
                setTextareaWidth(textNode.width() * scale);
                textarea.style.height = 'auto';
                textarea.style.height =
                    textarea.scrollHeight + textNode.fontSize() + 'px';
            });

            function handleOutsideClick(e) {

                if (e.target !== textarea) {
                    textNode.text(textarea.value);
                    removeTextarea();
                }
            }
            setTimeout(() => {
                window.addEventListener('click', handleOutsideClick);
            });
        })

        var tapCount = 0;
        var lastTapTime = 0;
        textNode.on('tap', (e) => {
            var currentTime = new Date().getTime();
            console.log(currentTime);
            if (currentTime - lastTapTime < 300) {
                // 双击事件逻辑
                console.log('Double Tap!');

                // 执行双击后的操作
                fn()
                textNode.hide();
                tr.hide();
                layer.draw();


                var textPosition = textNode.absolutePosition();

                // then lets find position of stage container on the page:
                var stageBox = stage.container().getBoundingClientRect();
                const zoom = document.body.style.zoom || 1;
                const scaleValue = (1 / zoom).toFixed(3);
                // so position of textarea will be the sum of positions above:
                var areaPosition = {
                    x: stageBox.left * scaleValue + textPosition.x,
                    y: stageBox.top * scaleValue + textPosition.y
                };
                // create textarea and style it
                var textarea = document.createElement('textarea');
                document.body.appendChild(textarea);
                textarea.value = textNode.text();
                textarea.style.position = 'absolute';
                textarea.style.top = areaPosition.y + 'px';
                textarea.style.left = areaPosition.x + 'px';
                textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px';
                textarea.style.height =
                    textNode.height() - textNode.padding() * 2 + 5 + 'px';
                textarea.style.fontSize = textNode.fontSize() + 'px';
                textarea.style.border = 'none';
                textarea.style.padding = '0px';
                textarea.style.margin = '0px';
                textarea.style.overflow = 'hidden';
                textarea.style.background = 'none';
                textarea.style.outline = 'none';
                textarea.style.resize = 'none';
                textarea.style.letterSpacing = textNode.letterSpacing() + 'px';
                textarea.style.lineHeight = textNode.lineHeight();
                textarea.style.fontFamily = textNode.fontFamily();
                textarea.style.transformOrigin = 'left top';
                textarea.style.textAlign = textNode.align();
                textarea.style.color = textNode.fill();
                let rotation = textNode.getRotation();
                var transform = '';

                if (rotation) {
                    transform += 'rotateZ(' + rotation + 'deg)';

                }


                var px = 0;
                // also we need to slightly move textarea on firefox
                // because it jumps a bit
                var isFirefox =
                    navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                if (isFirefox) {
                    px += 2 + Math.round(textNode.fontSize() / 20);
                }
                transform += 'translateY(-' + px + 'px)';

                textarea.style.transform = transform;

                // reset height
                textarea.style.height = 'auto';
                // after browsers resized it we can set actual value
                textarea.style.height = textarea.scrollHeight + 3 + 'px';

                textarea.focus();

                function removeTextarea() {
                    textarea.parentNode.removeChild(textarea);
                    window.removeEventListener('touchstart', handleOutsideClick);
                    textNode.show();
                    tr.show();
                    tr.forceUpdate();
                    layer.draw();
                }

                function setTextareaWidth(newWidth) {
                    if (!newWidth) {
                        // set width for placeholder
                        newWidth = textNode.placeholder.length * textNode.fontSize();
                    }
                    // some extra fixes on different browsers
                    var isSafari = /^((?!chrome|android).)*safari/i.test(
                        navigator.userAgent
                    );
                    var isFirefox =
                        navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                    if (isSafari || isFirefox) {
                        newWidth = Math.ceil(newWidth);
                    }

                    var isEdge =
                        document.documentMode || /Edge/.test(navigator.userAgent);
                    if (isEdge) {
                        newWidth += 1;
                    }
                    textarea.style.width = newWidth + 'px';
                }

                textarea.addEventListener('keydown', function (e) {
                    // hide on enter
                    // but don't hide on shift + enter
                    if (e.keyCode === 13 && !e.shiftKey) {
                        textNode.text(textarea.value);
                        removeTextarea();
                    }
                    // on esc do not set value back to node
                    if (e.keyCode === 27) {
                        removeTextarea();
                    }
                });

                textarea.addEventListener('keydown', function (e) {
                    let scale = textNode.getAbsoluteScale().x;
                    setTextareaWidth(textNode.width() * scale);
                    textarea.style.height = 'auto';
                    textarea.style.height =
                        textarea.scrollHeight + textNode.fontSize() + 'px';
                });

                function handleOutsideClick(e) {
                    console.log(e)
                    if (e.target !== textarea) {
                        textNode.text(textarea.value);
                        removeTextarea();
                    }
                }
                setTimeout(() => {
                    window.addEventListener('touchstart', handleOutsideClick);
                });


                tapCount = 0;
            } else {
                // 单击事件逻辑
                console.log('Single Tap');

                lastTapTime = currentTime;
                tapCount += 1;
            }
        })


    }










};

function mouseMove(stage) {
    stage.on("mousemove touchmove ", (e) => {
        if (e.target !== stage) {
            stage.container().style.cursor = "move";
            if (e.target.attrs.name === 'gridLv') {
                stage.container().style.cursor = "col-resize";
            }
            if (e.target.attrs.name === 'gridLh') {
                stage.container().style.cursor = "row-resize";
            }
            if (e.target.attrs.name === 'fill') {
                stage.container().style.cursor = "default";
            }
            // if (e.target.attrs.x == 300 || e.target.attrs.y == 300) {
            //     console.log("居中！！！！！！！！！！！！！！！！！");
            //     return;
            // }
        } else {
            //stage.container().style.cursor = "default";
        }


    });
};
export {
    clickTap,
    mouseMove
}